/**
 * @author       david.loehr@zumper.com (David Loehr)
 * @copyright    Copyright (c) 2025, Zumper
 */

import { nullReducer, payloadKeyReducer, payloadReducer } from '@zcode/reducers'
import type { DetailLifestyles } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleAction, handleActions } from 'redux-actions'
import {
  RECEIVE_LIFESTYLE_SCORES_FOR_ADDRESS_ID,
  RECEIVE_LIFESTYLE_SCORES_FOR_GROUP_ID,
  START_FETCHING_LIFESTYLE_SCORES_FOR_ADDRESS_ID,
  START_FETCHING_LIFESTYLE_SCORES_FOR_GROUP_ID,
} from './constants'
import type { ActionTypes } from './types'

export const lifestylesReducer = combineReducers<DetailLifestyles, ActionTypes>({
  addressId: handleAction<
    DetailLifestyles['addressId'],
    ActionTypes,
    typeof RECEIVE_LIFESTYLE_SCORES_FOR_ADDRESS_ID
  >(RECEIVE_LIFESTYLE_SCORES_FOR_ADDRESS_ID, payloadKeyReducer('addressId'), null),
  dataForAddressId: handleAction<
    DetailLifestyles['dataForAddressId'],
    ActionTypes,
    typeof RECEIVE_LIFESTYLE_SCORES_FOR_ADDRESS_ID
  >(RECEIVE_LIFESTYLE_SCORES_FOR_ADDRESS_ID, payloadKeyReducer('data'), null),
  dataForGroupId: handleAction<
    DetailLifestyles['dataForGroupId'],
    ActionTypes,
    typeof RECEIVE_LIFESTYLE_SCORES_FOR_GROUP_ID
  >(RECEIVE_LIFESTYLE_SCORES_FOR_GROUP_ID, payloadKeyReducer('data'), null),
  fetchingAddressId: handleActions<DetailLifestyles['fetchingAddressId'], ActionTypes>(
    {
      [RECEIVE_LIFESTYLE_SCORES_FOR_ADDRESS_ID]: nullReducer,
      [START_FETCHING_LIFESTYLE_SCORES_FOR_ADDRESS_ID]: payloadReducer,
    },
    null
  ),
  fetchingGroupId: handleActions<DetailLifestyles['fetchingGroupId'], ActionTypes>(
    {
      [RECEIVE_LIFESTYLE_SCORES_FOR_GROUP_ID]: nullReducer,
      [START_FETCHING_LIFESTYLE_SCORES_FOR_GROUP_ID]: payloadReducer,
    },
    null
  ),
  groupId: handleAction<
    DetailLifestyles['groupId'],
    ActionTypes,
    typeof RECEIVE_LIFESTYLE_SCORES_FOR_GROUP_ID
  >(RECEIVE_LIFESTYLE_SCORES_FOR_GROUP_ID, payloadKeyReducer('groupId'), null),
})
